import React, { useEffect, useRef, useState } from "react";
import { ABONO_URLS, BUY_URL, EMAIL, ENTRADAS_URL, INSTAGRAM_URL, PERMISO_URL, PUNTOS_FISICOS } from "./config";
import { Faltan } from "./Chrome26";

// Objetos entregados por diseño (Landing/images) → src/assets/qlk26/v2
import fecha from "../../assets/qlk26/v2/fecha-v4.png";
import festiTexto from "../../assets/qlk26/v2/festi-texto-v4.png";
import listGeneral from "../../assets/qlk26/v2/list-general.png";
import listVip from "../../assets/qlk26/v2/list-vip.png";
import listUltra from "../../assets/qlk26/v2/list-ultra.png";
import listParking from "../../assets/qlk26/v2/list-parking.png";
import forma01 from "../../assets/qlk26/v2/forma01.png";
import genTitulo from "../../assets/qlk26/v2/gen-titulo.png";
import genCanta from "../../assets/qlk26/v2/gen-canta.png";
import genIncluye from "../../assets/qlk26/v2/gen-incluye.png";
import compartir from "../../assets/qlk26/v2/gen-compartir.png";
import genForma02 from "../../assets/qlk26/v2/gen-forma02.png";
import vipTitulo from "../../assets/qlk26/v2/vip-titulo.png";
import vipSubti from "../../assets/qlk26/v2/vip-subti.png";
import vipBajada from "../../assets/qlk26/v2/vip-bajada.png";
import vipIncluye from "../../assets/qlk26/v2/vip-incluye.png";
import ultraTitulo from "../../assets/qlk26/v2/ultra-titulo-v4.png";
import ultraBajada from "../../assets/qlk26/v2/ultra-bajada.png";
import ultraIncluye from "../../assets/qlk26/v2/ultra-incluye.png";
import ultraCierre from "../../assets/qlk26/v2/ultra-cierre.png";
import abono2General from "../../assets/qlk26/v2/abono2-general.png";
import abono2Vip from "../../assets/qlk26/v2/abono2-vip.png";
import abono2Ultra from "../../assets/qlk26/v2/abono2-ultra.png";
import abonoPrecioGeneral from "../../assets/qlk26/v2/abono-precio-general.png";
import abonoPrecioVip from "../../assets/qlk26/v2/abono-precio-vip.png";
import abonoPrecioUltra from "../../assets/qlk26/v2/abono-precio-ultra.png";
import abonoX2 from "../../assets/qlk26/v2/abono-x2dias.png";
import abonosTitulo from "../../assets/qlk26/v2/abonos-titulo.png";
import sectoresPc from "../../assets/qlk26/v2/sectores-pc-v2.jpg";
import sectoresCelu from "../../assets/qlk26/v2/sectores-celu.jpg";
import cuotasImg from "../../assets/qlk26/v2/cuotas.png";
import parkTitulo from "../../assets/qlk26/v2/park-titulo.png";
import parkBajada from "../../assets/qlk26/v2/park-bajada.png";
import parkAgrega from "../../assets/qlk26/v2/park-agrega.png";
import parkFlechasA from "../../assets/qlk26/v2/park-flechas-a.png";
import parkFlechasB from "../../assets/qlk26/v2/park-flechas-b.png";
import parkPara from "../../assets/qlk26/v2/park-para.png";
import puntosTituloPc from "../../assets/qlk26/v2/puntos-titulo-pc.png";
import puntosTituloCelu from "../../assets/qlk26/v2/puntos-titulo-celu.png";
import puntosOnline from "../../assets/qlk26/v2/puntos-online.png";
import puntosMaps from "../../assets/qlk26/v2/puntos-maps.png";
import kioskoNewen from "../../assets/qlk26/v2/kiosko-newen.png";
import kioskoArleking from "../../assets/qlk26/v2/kiosko-arleking.png";
import kioskoLosPepos from "../../assets/qlk26/v2/kiosko-lospepos.png";
import contactoTitulo from "../../assets/qlk26/v2/contacto-titulo.png";
import contactoIg from "../../assets/qlk26/v2/contacto-ig.png";
import contactoMail from "../../assets/qlk26/v2/contacto-mail.png";
// Extraídos del PDF (todavía sin objeto propio)
import genFrase from "../../assets/qlk26/gen-frase.png";
import lineupPc from "../../assets/qlk26/v2/lineup-pc.png";
import lineupCelu from "../../assets/qlk26/v2/lineup-celu.jpg";

// px del lienzo 1920 (tamaño natural de los objetos)
const px = (x) => `calc(var(--px) * ${x})`;
const Img = ({ src, w, alt = "", className = "", style }) => (
  <img className={className} src={src} alt={alt} style={{ width: px(w), ...style }} />
);


// Beneficios (texto oficial). Los usan las páginas de cada entrada (BENEFICIOS)
// y los abonos desplegables (ABONOS). Si cambia un beneficio, se corrige solo acá.
// cls: resaltado como en el diseño (q26-pink / q26-yellow / it = itálica).
const BENEFICIOS = {
  general: [
    { t: "Ingreso al predio" },
    { t: "Espacio gastronómico con los mejores food trucks (no incluye consumición)" },
    { t: "Barras habilitadas en todo el festival (no incluye consumición)" },
    { t: "Baños disponibles en distintos puntos" },
    { t: "Acceso a las zonas de experiencias con sponsors y marcas aliadas" },
  ],
  vip: [
    { t: "Ingreso por acceso diferenciado" },
    { t: "Ubicación destacada frente al escenario" },
    { t: "Baños exclusivos" },
    { t: "Barras preferenciales", cls: "q26-pink" },
    { t: "2 consumiciones de bebida incluidas", cls: "q26-yellow" },
    { t: "Acceso al patio gastronómico con food trucks (no incluye consumición)" },
    { t: "Zonas de experiencias exclusivas con sponsors y marcas aliadas" },
  ],
  ultra: [
    { t: "Ingreso preferencial por acceso VIP", cls: "q26-yellow" },
    { t: "Incluye ticket de parking con espacio reservado dentro del predio" },
    { t: "Acceso directo a un sector diferenciado, sobre plataforma elevada frente al escenario", cls: "q26-pink" },
    { t: "Baños y barra VIP" },
    { t: "4 consumiciones de bebida + 2 de comida incluidas", cls: "it" },
    { t: "Acceso al patio gastronómico con food trucks" },
    { t: "Zonas de experiencias exclusivas con sponsors y marcas aliadas", cls: "it" },
  ],
};

const ABONOS = {
  general: [
    { t: "Ingreso al predio por día." },
    { t: "Espacio gastronómico con los mejores food trucks (no incluye consumición)." },
    { t: "Barras habilitadas en todo el festival (no incluye consumición)." },
    { t: "Baños disponibles en distintos puntos." },
    { t: "Acceso a las zonas de experiencias con sponsors y marcas aliadas." },
  ],
  vip: [
    { t: "Ingreso por acceso diferenciado cada día." },
    { t: "Ubicación destacada frente al escenario." },
    { t: "Baños exclusivos." },
    { t: "Barras preferenciales.", cls: "q26-pink" },
    { t: "2 consumiciones de bebida incluidas por día.", cls: "q26-yellow" },
    { t: "Acceso al patio gastronómico con food trucks (no incluye consumición)." },
    { t: "Zonas de experiencias exclusivas con sponsors y marcas aliadas." },
  ],
  ultra: [
    { t: "Ingreso preferencial por acceso VIP ambos dias.", cls: "q26-yellow" },
    { t: "Incluye ticket de parking con espacio reservado dentro del predio." },
    { t: "Acceso directo a un sector diferenciado, sobre plataforma elevada frente al escenario.", cls: "q26-pink" },
    { t: "Baños y barra VIP." },
    { t: "4 consumiciones de bebida + 1 de comida incluida por cada día.", cls: "it" },
    { t: "Acceso al patio gastronómico con food trucks." },
    { t: "Zonas de experiencias exclusivas con sponsors y marcas aliadas.", cls: "it" },
  ],
};

const ListaBeneficios = ({ items }) => (
  <ul className="q26-list">
    {items.map((b) => (
      <li key={b.t} className={b.cls}>
        {b.t}
      </li>
    ))}
  </ul>
);

// ---------- 1. HOME ----------
export const Hero = React.forwardRef((props, ref) => (
  <section id="home" ref={ref} className="q26-section q26-hero" aria-label="QLK Fest 2da edición">
    <div className="q26-hero-img q26-only-d" />
    <div className="q26-hero-mobile">
      <div className="photo" />
      <div className="info">
        <img className="fecha" src={fecha} alt="6 y 7 de Diciembre · Jockey Club - Río Cuarto, Córdoba" />
        <Faltan />
      </div>
    </div>
  </section>
));

// ---------- 2. EL FESTI ----------
// Desktop: texto como imagen del diseño; las flechas llevan a la sección anterior / siguiente.
export const ElFesti = React.forwardRef(({ onNavigate }, ref) => (
  <section id="festi" ref={ref} className="q26-section" aria-label="El Festi">
    <div className="q26-festi-img q26-only-d">
      <Img
        src={festiTexto}
        w={1433}
        alt="QLK Fest 2. Redoblamos la apuesta. Para los fanáticos de vivirla, cantarla y bailarla hasta el final. Vuelve QLK Fest al Jockey Club de Río Cuarto, con el ADN de Q' Lokura, dos días a pura fiesta y un line up a la altura de un festival inolvidable. La segunda edición se vive con todo."
      />
      <button className="q26-arrow-hit left" onClick={() => onNavigate("home")} aria-label="Anterior" />
      <button className="q26-arrow-hit right" onClick={() => onNavigate("entradas")} aria-label="Siguiente" />
    </div>
    <p className="q26-festi-text q26-only-m">
      <strong>
        <span className="q26-pink">QLK FEST 2.</span> REDOBLAMOS LA APUESTA.
      </strong>{" "}
      Para los fanáticos de vivirla, cantarla y bailarla hasta el final. Vuelve QLK Fest al Jockey Club
      de Río Cuarto, con el ADN de Q’ Lokura, dos días a pura fiesta y un line up a la altura de un
      festival inolvidable.{" "}
      <span className="q26-yellow">La segunda edición se vive con todo.</span>
    </p>
  </section>
));

// ---------- 3. ENTRADAS ----------
// Izquierda: entradas (van a su detalle) · derecha: abonos 2 días (van a la sección Abonos).
export const Entradas = React.forwardRef(({ onNavigate }, ref) => {
  const entradas = [
    { id: "entrada-general", img: listGeneral, w: 551, alt: "General" },
    { id: "entrada-vip", img: listVip, w: 586, alt: "VIP Full Standing" },
    { id: "entrada-ultra", img: listUltra, w: 593, alt: "Ultra VIP" },
    { id: "entrada-parking", img: listParking, w: 303, alt: "Parking" },
  ];
  const abonos = [
    { key: "general", img: abono2General, w: 451, alt: "Abono General" },
    { key: "vip", img: abono2Vip, w: 589, alt: "Abono VIP Full Standing" },
    { key: "ultra", img: abono2Ultra, w: 502, alt: "Abono Ultra VIP" },
  ];
  return (
    <section id="entradas" ref={ref} className="q26-section" aria-label="Entradas">
      <div className="q26-entradas-wrap">
        <Img className="q26-deco-left" src={forma01} w={324} />
        <div className="q26-entradas-cols">
          <div className="q26-entradas-col">
            {entradas.map((it) => (
              <button key={it.id} className="q26-entrada-link" onClick={() => onNavigate(it.id)} aria-label={it.alt}>
                <Img src={it.img} w={it.w} alt={it.alt} />
              </button>
            ))}
          </div>
          <div className="q26-entradas-col left">
            {abonos.map((it) => (
              <button key={it.alt} className="q26-entrada-link" onClick={() => {
                  onNavigate("abonos");
                  window.dispatchEvent(new CustomEvent(ABONO_EVENT, { detail: it.key }));
                }} aria-label={it.alt}>
                <Img src={it.img} w={it.w} alt={it.alt} />
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
});

// "Compartilo": copia el link directo a la sección para pegarlo donde quieran.
const ShareButton = ({ section }) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    const url = `${window.location.origin}${window.location.pathname}#${section}`;
    try {
      await navigator.clipboard.writeText(url);
    } catch (e) {
      // navegadores sin permiso de portapapeles
      const ta = document.createElement("textarea");
      ta.value = url;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      ta.remove();
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2200);
  };
  return (
    <button className="q26-share" onClick={copy} aria-label="Copiar link para compartir">
      <Img src={compartir} w={248} alt="Compartilo con gente que sabe vivirlo" />
      {copied && (
        <span className="q26-share-toast" role="status">
          ¡Link copiado!
        </span>
      )}
    </button>
  );
};

// "6 cuotas sin interés" (Galicia · Visa · Mastercard), chiquito debajo de cada COMPRAR
const Cuotas = () => (
  <img className="q26-cuotas" src={cuotasImg} alt="6 cuotas sin interés con Galicia, Visa y Mastercard" />
);

// Botón COMPRAR de cada entrada (va debajo de "Compartilo"), con las cuotas debajo
const ComprarEntrada = () => (
  <div className="q26-buy-wrap">
    <a className="q26-buy q26-entrada-buy" href={ENTRADAS_URL} target="_blank" rel="noopener noreferrer">
      COMPRAR
    </a>
    <Cuotas />
  </div>
);

// Columna derecha de cada entrada: sello "Compartilo" y debajo COMPRAR
const Aside = ({ section }) => (
  <div className="q26-aside">
    <ShareButton section={section} />
    <ComprarEntrada />
  </div>
);

// ---------- 4. GENERAL ----------
export const EntradaGeneral = React.forwardRef((props, ref) => (
  <section id="entrada-general" ref={ref} className="q26-section" aria-label="Entrada General">
    <div className="q26-detalle">
      <Img className="q26-titulo" src={genTitulo} w={763} alt="General · Para fanáticos de vivirla" />
      <Img
        className="q26-only-d q26-sub"
        src={genCanta}
        w={762}
        alt="Cantá cada tema, bailá con tu gente y viví el QLK FEST a pleno."
      />
      <p className="q26-detalle-sub q26-yellow q26-only-m">
        Cantá cada tema, bailá con tu gente y viví el QLK FEST a pleno.
      </p>
      <div className="q26-detalle-body">
        <div className="q26-m-list">
          <Img className="q26-regla" src={genIncluye} w={194} alt="Tu entrada incluye:" />
          <div>
            <ListaBeneficios items={BENEFICIOS.general} />
            <Img className="q26-frase q26-frase-gen" src={genFrase} w={630} alt="Las ganas de vivirla las ponés vos." />
          </div>
        </div>
        <Aside section="entrada-general" />
      </div>
      <Img className="q26-forma02 q26-only-d" src={genForma02} w={404} />
    </div>
  </section>
));

// ---------- 5. VIP FULL STANDING ----------
export const EntradaVip = React.forwardRef((props, ref) => (
  <section id="entrada-vip" ref={ref} className="q26-section" aria-label="Entrada VIP Full Standing">
    <div className="q26-detalle">
      <Img className="q26-titulo" src={vipTitulo} w={649} alt="VIP Full Standing" />
      <Img className="q26-titulo" src={vipSubti} w={874} alt="Para fanáticos de vivirla bien cerca" />
      <Img
        className="q26-only-d q26-sub"
        src={vipBajada}
        w={601}
        alt="Frente al escenario, con tu gente y cantando cada tema."
      />
      <p className="q26-detalle-sub q26-yellow q26-only-m">Frente al escenario, con tu gente y cantando cada tema.</p>
      <div className="q26-detalle-body">
        <div className="q26-m-list">
          <Img className="q26-regla" src={vipIncluye} w={82} alt="Tu entrada incluye:" />
          <ListaBeneficios items={BENEFICIOS.vip} />
        </div>
        <Aside section="entrada-vip" />
      </div>
    </div>
  </section>
));

// ---------- 6. ULTRA VIP ----------
export const EntradaUltra = React.forwardRef((props, ref) => (
  <section id="entrada-ultra" ref={ref} className="q26-section" aria-label="Entrada Ultra VIP">
    <div className="q26-detalle">
      <Img className="q26-titulo" src={ultraTitulo} w={680} alt="Ultra VIP · El plan viene con todo" />
      <Img
        className="q26-only-d q26-sub"
        src={ultraBajada}
        w={495}
        alt="Tu gente, tus temas y una vista para no perderte nada."
      />
      <p className="q26-detalle-sub q26-pink q26-only-m">Tu gente, tus temas y una vista para no perderte nada.</p>
      <div className="q26-detalle-body">
        <div className="q26-m-list">
          <Img className="q26-regla" src={ultraIncluye} w={85} alt="Tu entrada incluye:" />
          <ListaBeneficios items={BENEFICIOS.ultra} />
        </div>
        <Aside section="entrada-ultra" />
      </div>
      <Img
        className="q26-frase"
        src={ultraCierre}
        w={966}
        alt="Toda la energía del QLK. El privilegio de vivirlo en Ultra VIP."
      />
    </div>
  </section>
));

// ---------- 7. PARKING ----------
export const EntradaParking = React.forwardRef((props, ref) => (
  <section id="entrada-parking" ref={ref} className="q26-section" aria-label="Parking">
    <div className="q26-detalle">
      <Img className="q26-titulo q26-park-tit" src={parkTitulo} w={303} alt="Parking" />
      <Img className="q26-titulo" src={parkBajada} w={1079} alt="Del auto al show, en unos pasos." />
      {/* la imagen del texto se separó en partes para que quede centrado,
          con las flechas a ambos lados (iguales, espejadas) */}
      <Img className="q26-park-agrega" src={parkAgrega} w={725} alt="Agregá tu parking y estacioná dentro del predio." />
      <div className="q26-park-row">
        <Img className="q26-park-flechas" src={parkFlechasA} w={182} alt="" />
        <Img className="q26-park-para" src={parkPara} w={380} alt="Para entradas General y VIP Full Standing." />
        <Img className="q26-park-flechas" src={parkFlechasB} w={182} alt="" />
      </div>
      <div className="q26-park-cta">
        <ShareButton section="entrada-parking" />
        <ComprarEntrada />
      </div>
    </div>
  </section>
));

// ---------- 8. ABONOS 2 DÍAS ----------
// Cada abono es un botón: al tocarlo se despliega debajo lo que incluye.
// Se abre uno a la vez. Desde Entradas se puede abrir uno directo (evento "q26-abono").
export const ABONO_EVENT = "q26-abono";

// Título "ABONOS" + leyenda
const AbonosHead = ({ className = "" }) => (
  <div className={"q26-abonos-head " + className}>
    <Img className="q26-abonos-titulo" src={abonosTitulo} w={416} alt="Abonos" />
    <p className="q26-abonos-leyenda">Hacé click en cada uno para ver qué incluye</p>
  </div>
);

export const Abonos = React.forwardRef((props, ref) => {
  const [open, setOpen] = useState(null);
  const rows = [
    { key: "general", img: abono2General, w: 451, precio: abonoPrecioGeneral, pw: 305, alt: "Abono General $70.000 + Service Charge" },
    { key: "vip", img: abono2Vip, w: 589, precio: abonoPrecioVip, pw: 328, alt: "Abono VIP Full Standing $120.000 + Service Charge" },
    { key: "ultra", img: abono2Ultra, w: 502, precio: abonoPrecioUltra, pw: 349, alt: "Abono Ultra VIP $220.000 + Service Charge" },
  ];

  const itemRefs = useRef({});

  useEffect(() => {
    const onOpen = (e) => setOpen(e.detail);
    window.addEventListener(ABONO_EVENT, onOpen);
    return () => window.removeEventListener(ABONO_EVENT, onOpen);
  }, []);

  // Al abrir un abono, mover la página lo justo para que se vea toda su lista
  // arriba del pie, sin que su título quede debajo del header.
  useEffect(() => {
    if (!open) return;
    const t = setTimeout(() => {
      const el = itemRefs.current[open];
      if (!el) return;
      const header = document.querySelector(".q26-header");
      const footer = document.querySelector(".q26-footer");
      const top = header ? header.getBoundingClientRect().bottom + 8 : 0;
      // en celular además se deja lugar al botón flotante de música (46px + margen)
      const musica = window.innerWidth <= 768 ? 58 : 0;
      const bottom = window.innerHeight - (footer ? footer.offsetHeight : 0) - 12 - musica;
      // alto final (lista abierta del todo), sin depender de que termine la animación
      const head = el.querySelector(".q26-abono-head");
      const inner = el.querySelector(".q26-abono-inner");
      const r = el.getBoundingClientRect();
      const finalBottom = r.top + head.offsetHeight + (inner ? inner.scrollHeight : 0) + 40;
      let delta = 0;
      if (finalBottom > bottom) delta = finalBottom - bottom;
      if (r.top - delta < top) delta = r.top - top;
      if (Math.abs(delta) > 2) window.scrollBy({ top: delta, behavior: "smooth" });
    }, 60);
    return () => clearTimeout(t);
  }, [open]);

  return (
    <section id="abonos" ref={ref} className="q26-section" aria-label="Abonos 2 días">
      <AbonosHead className="q26-only-m" />
      <div className="q26-abonos">
        <Img className="q26-abonos-x2" src={abonoX2} w={138} alt="2 días" />
        <div className="q26-abonos-col">
        <AbonosHead className="q26-only-d" />
        <div className="q26-abonos-list">
          {rows.map((r) => {
            const isOpen = open === r.key;
            return (
              <div
                key={r.key}
                ref={(node) => {
                  itemRefs.current[r.key] = node;
                }}
                className={"q26-abono" + (isOpen ? " is-open" : "")}
              >
                <button
                  className="q26-abono-head"
                  onClick={() => setOpen(isOpen ? null : r.key)}
                  aria-expanded={isOpen}
                  aria-controls={`abono-${r.key}`}
                >
                  <Img src={r.img} w={r.w} alt={r.alt} />
                  <Img src={r.precio} w={r.pw} alt="" />
                  <span className="q26-abono-chevron" aria-hidden="true" />
                </button>
                <div id={`abono-${r.key}`} className="q26-abono-body" role="region">
                  <div className="q26-abono-inner">
                    <ListaBeneficios items={ABONOS[r.key]} />
                    <a
                      className="q26-buy q26-abono-buy"
                      href={ABONO_URLS[r.key]}
                      target="_blank"
                      rel="noopener noreferrer"
                      tabIndex={isOpen ? 0 : -1}
                    >
                      COMPRAR
                    </a>
                    <Cuotas />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        </div>
        {/* compu: el detalle del abono elegido va en un panel a la derecha (los títulos no se mueven).
            En celular se usa el desplegable de cada abono. */}
        <div className="q26-abono-panel q26-only-d" aria-live="polite">
          {open ? (
            <div key={open} className="q26-abono-panel-inner">
              <ListaBeneficios items={ABONOS[open]} />
              <a className="q26-buy q26-abono-buy" href={ABONO_URLS[open]} target="_blank" rel="noopener noreferrer">
                COMPRAR
              </a>
              <Cuotas />
            </div>
          ) : (
            <p className="q26-abono-hint">Tocá un abono para ver qué incluye</p>
          )}
        </div>
      </div>
    </section>
  );
});

// ---------- 8. LINE UP ----------
export const LineUp = React.forwardRef((props, ref) => (
  <section id="lineup" ref={ref} className="q26-section q26-lineup2" aria-label="Line Up">
    <picture>
      <source media="(max-width: 768px)" srcSet={lineupCelu} />
      <img
        className="q26-lineup-img"
        src={lineupPc}
        alt="Line up: Q'Lokura, El Chaqueño Palavecino, Los Tekis, Los Herrera, Campedrinos + DJs y artistas en vivo"
      />
    </picture>
  </section>
));

// ---------- SECTORES ----------
// Plano del predio: imagen horizontal en compu y recorte cuadrado en celu.
export const Sectores = React.forwardRef((props, ref) => (
  <section id="sectores" ref={ref} className="q26-section q26-sectores" aria-label="Sectores">
    <picture>
      <source media="(max-width: 768px)" srcSet={sectoresCelu} />
      <img
        className="q26-sectores-img"
        src={sectoresPc}
        alt="Sectores: Ultra VIP, VIP Standing y General frente al escenario"
      />
    </picture>
  </section>
));

// ---------- 10. PUNTOS DE VENTA ----------
const KIOSKOS = {
  newen: { img: kioskoNewen, w: 368 },
  arleking: { img: kioskoArleking, w: 325 },
  lospepos: { img: kioskoLosPepos, w: 389 },
};

export const PuntosVenta = React.forwardRef((props, ref) => (
  <section id="puntos" ref={ref} className="q26-section" aria-label="Puntos de venta">
    <div className="q26-puntos-top">
      <a className="q26-online" href={BUY_URL} target="_blank" rel="noopener noreferrer" aria-label="Comprar online">
        <Img src={puntosOnline} w={226} alt="Online: click y es tuya" />
      </a>
      <Img className="titulo q26-only-d" src={puntosTituloPc} w={918} alt="Puntos de venta físicos" />
      <img className="titulo q26-only-m" src={puntosTituloCelu} alt="Puntos de venta físicos" />
    </div>
    <div className="q26-puntos-grid">
      {PUNTOS_FISICOS.map((p) => (
        <div key={p.id} className="q26-punto">
          {KIOSKOS[p.id] ? (
            <Img className="q26-kiosko" src={KIOSKOS[p.id].img} w={KIOSKOS[p.id].w} alt={`${p.nombre}: ${p.detalle}`} />
          ) : (
            // local sin imagen de diseño: mismo estilo en texto
            <div className="q26-kiosko-txt">
              <h3>{p.nombre}</h3>
              {[].concat(p.direccion || p.detalle).map((d) => (
                <p key={d}>{d}</p>
              ))}
              {p.horario && <p className="small">{p.horario}</p>}
            </div>
          )}
          <a className="q26-maps-img" href={p.maps} target="_blank" rel="noopener noreferrer">
            <Img src={puntosMaps} w={407} alt={`Ver ubicación de ${p.nombre} en Google Maps`} />
          </a>
        </div>
      ))}
    </div>
  </section>
));

// ---------- PERMISO DE MENORES (a completar con los objetos) ----------
export const Permiso = React.forwardRef((props, ref) => (
  <section id="permiso" ref={ref} className="q26-section" aria-label="Permiso de menores">
    <h2 className="q26-big-title">PERMISO</h2>
    <span className="q26-tag">MENORES DE EDAD</span>
    <p className="q26-permiso-text">
      Descargá la declaración jurada, completala y presentala en el ingreso junto al DNI.
    </p>
    <a className="q26-buy" href={PERMISO_URL} target="_blank" rel="noopener noreferrer">
      DESCARGAR PERMISO
    </a>
  </section>
));

// ---------- 11. CONTACTO ----------
// Mail: en compu abre un mail nuevo en Gmail (mailto no hace nada si la compu no tiene
// una app de correo configurada); en celular usa mailto (abre la app de mail del teléfono).
// En ambos casos además copia la dirección, por si usan otro proveedor.
const GMAIL_COMPOSE = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(EMAIL)}`;

const MailLink = () => {
  const [copied, setCopied] = useState(false);
  const isMobile = typeof window !== "undefined" && window.innerWidth <= 768;
  const onClick = () => {
    if (navigator.clipboard) navigator.clipboard.writeText(EMAIL).catch(() => {});
    setCopied(true);
    setTimeout(() => setCopied(false), 2200);
  };
  return (
    <a
      className="q26-share"
      href={isMobile ? `mailto:${EMAIL}` : GMAIL_COMPOSE}
      target={isMobile ? undefined : "_blank"}
      rel="noopener noreferrer"
      onClick={onClick}
    >
      <Img src={contactoMail} w={513} alt={`Escribinos a ${EMAIL}`} />
      {copied && (
        <span className="q26-share-toast" role="status">
          ¡Mail copiado!
        </span>
      )}
    </a>
  );
};

export const Contacto = React.forwardRef((props, ref) => (
  <section id="contacto" ref={ref} className="q26-section" aria-label="Contacto">
    <Img className="q26-contacto-titulo" src={contactoTitulo} w={1155} alt="Contacto" />
    <div className="q26-contacto-row">
      <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer">
        <Img src={contactoIg} w={257} alt="Instagram @qlkfest" />
      </a>
      <MailLink />
    </div>
  </section>
));
